module.exports = __webpack_public_path__ + "static/media/torah.0d89f4f4.svg";